import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Scale, ShoppingBag, Shield } from 'lucide-react';
const benefits = [{
  icon: Clock,
  title: 'Cocinar viandas para la semana en menos tiempo'
}, {
  icon: Scale,
  title: 'Controlar porciones y conservación'
}, {
  icon: ShoppingBag,
  title: 'Preparar ofertas simples para vender localmente'
}, {
  icon: Shield,
  title: 'Sentirte seguro/a con precios, etiquetas y entrega'
}];
export const BenefitsSection: React.FC = () => {
  return <section className="py-20 px-4 md:px-8 bg-white" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-primary mb-4" data-id="element-20">
            Con COCINA VIANDERA vas a poder:
          </h2>
          <div className="w-24 h-1 bg-brand-soft mx-auto rounded-full" data-id="element-21"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-22">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="flex flex-col items-center text-center p-6 rounded-2xl transition-all duration-300 hover:shadow-xl hover:shadow-brand-primary/5 border border-transparent hover:border-brand-cream" data-id="element-23">
              <div className="w-20 h-20 bg-brand-cream rounded-full flex items-center justify-center mb-6 text-brand-medium" data-id="element-24">
                <benefit.icon className="w-10 h-10" data-id="element-25" />
              </div>
              <h3 className="text-xl font-bold text-brand-text-dark leading-snug" data-id="element-26">
                {benefit.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
};